import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export function CoworldSwitcherTrigger({
  label,
  compactTrigger,
  open,
}: {
  readonly label: string;
  readonly compactTrigger: boolean;
  readonly open: boolean;
}) {
  return (
    <span
      {...stylex.props(
        styles.trigger,
        compactTrigger && styles.compact,
        open && styles.open,
      )}
    >
      <span {...stylex.props(styles.label)}>{label}</span>
      <svg
        width="9"
        height="5"
        viewBox="0 0 9 5"
        fill="none"
        aria-hidden
        {...stylex.props(styles.chevron, open && styles.chevronOpen)}
      >
        <path
          d="M1 .5 4.5 4 8 .5"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

const styles = stylex.create({
  trigger: {
    display: "flex",
    minWidth: 0,
    maxWidth: { default: 180, "@media (min-width: 768px)": 220 },
    alignItems: "center",
    gap: spacing.space4,
    paddingBlock: spacing.space8,
    fontFamily: fonts.mono,
    fontSize: fontSizes.label,
    lineHeight: "18px",
    letterSpacing: "0.14px",
    color: { default: colors.secondary, ":hover": colors.foreground },
  },
  compact: { maxWidth: { default: 52, "@media (min-width: 768px)": 220 } },
  open: { color: colors.foreground },
  label: {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  chevron: { flexShrink: 0 },
  chevronOpen: { transform: "rotate(180deg)" },
});
